"use strict";

exports.__esModule = true;
exports.MenuItems = exports.AuthenticatedMenuItems = exports.AuthenticatedDesktopMenuItems = void 0;
var MenuItems = [{
  id: 1,
  title: 'Store',
  url: '/store',
  sub_navigation_groups: [{
    id: 122,
    heading: 'Store',
    links: [{
      id: 119,
      label: 'Reward Vault',
      link: '/store/vault'
    }]
  }, {
    id: 6,
    heading: 'Platforms',
    links: [{
      id: 19,
      label: 'Steam',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=steam&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 20,
      label: 'Xbox',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=xbox&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 21,
      label: 'GOG',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=gog&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 22,
      label: 'Playstation',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=psn&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 23,
      label: 'Nintendo',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=nintendo&filters%5B0%5D%5Btype%5D=all'
    }]
  }, {
    id: 7,
    heading: 'Categories',
    links: [{
      id: 24,
      label: 'Action',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Action&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 25,
      label: 'Indie',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Indie&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 26,
      label: 'Adventure',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Adventure&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 27,
      label: 'Strategy',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Strategy&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 28,
      label: 'RPG',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=RPG&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 29,
      label: 'See More Games...',
      link: '/store/search?q=games&size=n_noddeno20_n'
    }]
  }, {
    id: 8,
    heading: 'Hot Deals',
    links: [{
      id: 30,
      label: 'Under $0.50',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_0.5_n&filters[0][values][0][from]=n_0_n&filters[0][values][0][name]=Under %240.50&filters[0][type]=all'
    }, {
      id: 31,
      label: '$0.50 to $1',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_1_n&filters[0][values][0][from]=n_0.5_n&filters[0][values][0][name]=%240.50 to %241&filters[0][type]=all'
    }, {
      id: 32,
      label: '$1 to $5',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_5_n&filters[0][values][0][from]=n_1_n&filters[0][values][0][name]=%241 to %245&filters[0][type]=all'
    }, {
      id: 33,
      label: '$5 to $10',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_10_n&filters[0][values][0][from]=n_5_n&filters[0][values][0][name]=%245 to %2410&filters[0][type]=all'
    }, {
      id: 34,
      label: '$10 and Up',
      link: '/store/search?q=game&size=n_20_n&filters%5B0%5D%5Bfield%5D=price&filters%5B0%5D%5Bvalues%5D%5B0%5D%5Bfrom%5D=n_10_n&filters%5B0%5D%5Bvalues%5D%5B0%5D%5Bname%5D=%2410%20%26%20Above&filters%5B0%5D%5Btype%5D=all'
    }]
  }, {
    id: 9,
    heading: 'Other Items',
    links: [{
      id: 35,
      label: 'Gaming Gift Cards',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Gaming%20Gift%20Cards&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 36,
      label: 'Other Gift Cards',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Other%20Gift%20Cards&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 37,
      label: 'Donations',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Donations&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 38,
      label: 'Support Creators',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=creators&filters%5B0%5D%5Btype%5D=all'
    }]
  }]
}, {
  id: 2,
  title: 'Earn',
  url: '/earn/summary',
  sub_navigation_groups: [{
    id: 10000,
    heading: 'Earn',
    links: [{
      id: 10001,
      label: 'Summary',
      link: '/earn/summary'
    }, {
      id: 10002,
      label: 'Miner Details',
      link: '/earn/machine-settings'
    }, {
      id: 10003,
      label: 'Mining FAQ',
      link: '/earn/mine'
    }]
  }]
}, {
  id: 3,
  title: 'About',
  url: 'https://salad.com/about',
  sub_navigation_groups: [{
    id: 3,
    heading: 'Company',
    links: [{
      id: 16,
      label: 'About Us',
      link: 'https://salad.com/about'
    }, {
      id: 7,
      label: 'Company Info',
      link: 'https://salad.com/company'
    }, {
      id: 6,
      label: 'Brand',
      link: 'https://salad.com/brand'
    }]
  }, {
    id: 4,
    heading: 'Community',
    links: [{
      id: 8,
      label: 'Discord',
      link: 'https://discord.gg/salad'
    }, {
      id: 17,
      label: 'Community Contributions',
      link: 'https://salad.com/community'
    }, {
      id: 9,
      label: 'Forums',
      link: 'https://www.reddit.com/r/SaladChefs/'
    }]
  }, {
    id: 5,
    heading: 'Documentation',
    links: [{
      id: 11,
      label: 'FAQs',
      link: 'https://support.salad.com/'
    }, {
      id: 12,
      label: 'App How-Tos',
      link: 'https://support.salad.com/hc/sections/360008576232-App-Guides'
    }, {
      id: 18,
      label: 'Salad Guides',
      link: 'https://salad.com/blog/salad-guide'
    }]
  }]
}, {
  id: 4,
  title: 'Blog',
  url: 'https://salad.com/blog',
  sub_navigation_groups: []
}];
exports.MenuItems = MenuItems;
var AuthenticatedMenuItems = [{
  id: 1,
  title: 'Store',
  url: '/store',
  sub_navigation_groups: [{
    id: 6,
    heading: 'Platforms',
    links: [{
      id: 19,
      label: 'Steam',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=steam&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 20,
      label: 'Xbox',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=xbox&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 21,
      label: 'GOG',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=gog&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 22,
      label: 'Playstation',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=psn&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 23,
      label: 'Nintendo',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=nintendo&filters%5B0%5D%5Btype%5D=all'
    }]
  }, {
    id: 7,
    heading: 'Categories',
    links: [{
      id: 24,
      label: 'Action',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Action&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 25,
      label: 'Indie',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Indie&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 26,
      label: 'Adventure',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Adventure&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 27,
      label: 'Strategy',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Strategy&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 28,
      label: 'RPG',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=RPG&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 29,
      label: 'See More Games...',
      link: '/store/search?q=games&size=n_20_n'
    }]
  }, {
    id: 8,
    heading: 'Hot Deals',
    links: [{
      id: 30,
      label: 'Under $0.50',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_0.5_n&filters[0][values][0][from]=n_0_n&filters[0][values][0][name]=Under %240.50&filters[0][type]=all'
    }, {
      id: 31,
      label: '$0.50 to $1',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_1_n&filters[0][values][0][from]=n_0.5_n&filters[0][values][0][name]=%240.50 to %241&filters[0][type]=all'
    }, {
      id: 32,
      label: '$1 to $5',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_5_n&filters[0][values][0][from]=n_1_n&filters[0][values][0][name]=%241 to %245&filters[0][type]=all'
    }, {
      id: 33,
      label: '$5 to $10',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_10_n&filters[0][values][0][from]=n_5_n&filters[0][values][0][name]=%245 to %2410&filters[0][type]=all'
    }, {
      id: 34,
      label: '$10 and Up',
      link: '/store/search?q=game&size=n_20_n&filters%5B0%5D%5Bfield%5D=price&filters%5B0%5D%5Bvalues%5D%5B0%5D%5Bfrom%5D=n_10_n&filters%5B0%5D%5Bvalues%5D%5B0%5D%5Bname%5D=%2410%20%26%20Above&filters%5B0%5D%5Btype%5D=all'
    }]
  }, {
    id: 9,
    heading: 'Other Items',
    links: [{
      id: 35,
      label: 'Gaming Gift Cards',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Gaming%20Gift%20Cards&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 36,
      label: 'Other Gift Cards',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Other%20Gift%20Cards&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 37,
      label: 'Donations',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Donations&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 38,
      label: 'Support Creators',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=creators&filters%5B0%5D%5Btype%5D=all'
    }]
  }]
}, {
  id: 2,
  title: 'Earn',
  url: '/earn/summary',
  sub_navigation_groups: [{
    id: 10000,
    heading: 'Earn',
    links: [{
      id: 10001,
      label: 'Summary',
      link: '/earn/summary'
    }, {
      id: 10002,
      label: 'Miner Details',
      link: '/earn/machine-settings'
    }, {
      id: 10003,
      label: 'Mining FAQ',
      link: '/earn/mine'
    }]
  }]
}, {
  id: 3,
  title: 'About',
  url: 'https://salad.com/about',
  sub_navigation_groups: [{
    id: 3,
    heading: 'Company',
    links: [{
      id: 16,
      label: 'About Us',
      link: 'https://salad.com/about'
    }, {
      id: 7,
      label: 'Company Info',
      link: 'https://salad.com/company'
    }, {
      id: 6,
      label: 'Brand',
      link: 'https://salad.com/brand'
    }]
  }, {
    id: 4,
    heading: 'Community',
    links: [{
      id: 8,
      label: 'Discord',
      link: 'https://discord.gg/salad'
    }, {
      id: 17,
      label: 'Community Contributions',
      link: 'https://salad.com/community'
    }, {
      id: 9,
      label: 'Forums',
      link: 'https://forums.salad.com/'
    }]
  }, {
    id: 5,
    heading: 'Documentation',
    links: [{
      id: 11,
      label: 'FAQs',
      link: 'https://support.salad.com/'
    }, {
      id: 12,
      label: 'App How-Tos',
      link: 'https://support.salad.com/hc/sections/360008576232-App-Guides'
    }, {
      id: 18,
      label: 'Salad Guides',
      link: 'https://salad.com/blog/salad-guide'
    }]
  }]
}, {
  id: 4,
  title: 'Blog',
  url: 'https://salad.com/blog',
  sub_navigation_groups: []
}, {
  id: 5,
  title: 'Account',
  url: '/account/summary',
  sub_navigation_groups: [{
    id: 6,
    heading: 'Account',
    links: [{
      id: 19,
      label: 'Profile',
      link: '/account/summary'
    }, {
      id: 20,
      label: 'Referrals',
      link: '/account/referrals'
    }, {
      id: 26,
      label: 'Bonuses',
      link: '/account/bonuses'
    }]
  }, {
    id: 7,
    heading: '',
    links: [{
      id: 21,
      label: 'Logout',
      link: '/',
      logout: true
    }]
  }]
}];
exports.AuthenticatedMenuItems = AuthenticatedMenuItems;
var AuthenticatedDesktopMenuItems = [{
  id: 1,
  title: 'Store',
  url: '/store',
  sub_navigation_groups: [{
    id: 6,
    heading: 'Platforms',
    links: [{
      id: 19,
      label: 'Steam',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=steam&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 20,
      label: 'Xbox',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=xbox&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 21,
      label: 'GOG',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=gog&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 22,
      label: 'Playstation',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=psn&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 23,
      label: 'Nintendo',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=platform&filters%5B0%5D%5Bvalues%5D%5B0%5D=nintendo&filters%5B0%5D%5Btype%5D=all'
    }]
  }, {
    id: 7,
    heading: 'Categories',
    links: [{
      id: 24,
      label: 'Action',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Action&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 25,
      label: 'Indie',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Indie&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 26,
      label: 'Adventure',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Adventure&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 27,
      label: 'Strategy',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Strategy&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 28,
      label: 'RPG',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=RPG&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 29,
      label: 'See More Games...',
      link: '/store/search?q=games&size=n_20_n'
    }]
  }, {
    id: 8,
    heading: 'Hot Deals',
    links: [{
      id: 30,
      label: 'Under $0.50',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_0.5_n&filters[0][values][0][from]=n_0_n&filters[0][values][0][name]=Under %240.50&filters[0][type]=all'
    }, {
      id: 31,
      label: '$0.50 to $1',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_1_n&filters[0][values][0][from]=n_0.5_n&filters[0][values][0][name]=%240.50 to %241&filters[0][type]=all'
    }, {
      id: 32,
      label: '$1 to $5',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_5_n&filters[0][values][0][from]=n_1_n&filters[0][values][0][name]=%241 to %245&filters[0][type]=all'
    }, {
      id: 33,
      label: '$5 to $10',
      link: '/store/search?q=game&size=n_20_n&filters[0][field]=price&filters[0][values][0][to]=n_10_n&filters[0][values][0][from]=n_5_n&filters[0][values][0][name]=%245 to %2410&filters[0][type]=all'
    }, {
      id: 34,
      label: '$10 and Up',
      link: '/store/search?q=game&size=n_20_n&filters%5B0%5D%5Bfield%5D=price&filters%5B0%5D%5Bvalues%5D%5B0%5D%5Bfrom%5D=n_10_n&filters%5B0%5D%5Bvalues%5D%5B0%5D%5Bname%5D=%2410%20%26%20Above&filters%5B0%5D%5Btype%5D=all'
    }]
  }, {
    id: 9,
    heading: 'Other Items',
    links: [{
      id: 35,
      label: 'Gaming Gift Cards',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Gaming%20Gift%20Cards&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 36,
      label: 'Other Gift Cards',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Other%20Gift%20Cards&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 37,
      label: 'Donations',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=Donations&filters%5B0%5D%5Btype%5D=all'
    }, {
      id: 38,
      label: 'Support Creators',
      link: '/store/search?size=n_20_n&filters%5B0%5D%5Bfield%5D=tags&filters%5B0%5D%5Bvalues%5D%5B0%5D=creators&filters%5B0%5D%5Btype%5D=all'
    }]
  }]
}, {
  id: 2,
  title: 'Earn',
  url: '/earn/summary',
  sub_navigation_groups: [{
    id: 10000,
    heading: 'Earn',
    links: [{
      id: 10001,
      label: 'Summary',
      link: '/earn/summary'
    }, {
      id: 10002,
      label: 'Miner Details',
      link: '/earn/machine-settings'
    }, {
      id: 10003,
      label: 'Mining FAQ',
      link: '/earn/mine'
    }]
  }]
}, {
  id: 3,
  title: 'About',
  url: 'https://salad.com/about',
  sub_navigation_groups: [{
    id: 3,
    heading: 'Company',
    links: [{
      id: 16,
      label: 'About Us',
      link: 'https://salad.com/about'
    }, {
      id: 7,
      label: 'Company Info',
      link: 'https://salad.com/company'
    }, {
      id: 6,
      label: 'Brand',
      link: 'https://salad.com/brand'
    }]
  }, {
    id: 4,
    heading: 'Community',
    links: [{
      id: 8,
      label: 'Discord',
      link: 'https://discord.gg/salad'
    }, {
      id: 17,
      label: 'Community Contributions',
      link: 'https://salad.com/community'
    }, {
      id: 9,
      label: 'Forums',
      link: 'https://www.reddit.com/r/SaladChefs/'
    }]
  }, {
    id: 5,
    heading: 'Documentation',
    links: [{
      id: 11,
      label: 'FAQs',
      link: 'https://support.salad.com/'
    }, {
      id: 12,
      label: 'App How-Tos',
      link: 'https://support.salad.com/hc/sections/360008576232-App-Guides'
    }, {
      id: 18,
      label: 'Salad Guides',
      link: 'https://salad.com/blog/salad-guide'
    }]
  }]
}, {
  id: 4,
  title: 'Blog',
  url: 'https://salad.com/blog',
  sub_navigation_groups: []
}, {
  id: 5,
  title: 'Account',
  url: '/account/summary',
  sub_navigation_groups: [{
    id: 6,
    heading: 'Account',
    links: [{
      id: 19,
      label: 'Profile',
      link: '/account/summary'
    }, {
      id: 20,
      label: 'Referrals',
      link: '/account/referrals'
    }, {
      id: 26,
      label: 'Bonuses',
      link: '/account/bonuses'
    }]
  }, {
    id: 7,
    heading: '',
    links: [{
      id: 21,
      label: 'Logout',
      link: '/',
      logout: true
    }]
  }]
}];
exports.AuthenticatedDesktopMenuItems = AuthenticatedDesktopMenuItems;